/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedAuditRouteImport } from './routes/_authenticated/audit'
import { Route as AuthenticatedCalculatorsRouteImport } from './routes/_authenticated/calculators'
import { Route as AuthenticatedHealthRouteImport } from './routes/_authenticated/health'
import { Route as AuthenticatedRetentionRouteImport } from './routes/_authenticated/retention'
import { Route as AuthenticatedSensorMappingsRouteImport } from './routes/_authenticated/sensor-mappings'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedOrganizationsIndexRouteImport } from './routes/_authenticated/organizations.index'
import { Route as AuthenticatedOrganizationsOrganizationIdRouteImport } from './routes/_authenticated/organizations.$organizationId'
import { Route as AuthenticatedPartnersIndexRouteImport } from './routes/_authenticated/partners.index'
import { Route as AuthenticatedPartnersPartnerIdRouteImport } from './routes/_authenticated/partners.$partnerId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAuditRoute = AuthenticatedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCalculatorsRoute =
  AuthenticatedCalculatorsRouteImport.update({
    id: '/calculators',
    path: '/calculators',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHealthRoute = AuthenticatedHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRetentionRoute = AuthenticatedRetentionRouteImport.update({
  id: '/retention',
  path: '/retention',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSensorMappingsRoute =
  AuthenticatedSensorMappingsRouteImport.update({
    id: '/sensor-mappings',
    path: '/sensor-mappings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrganizationsIndexRoute =
  AuthenticatedOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationsOrganizationIdRoute =
  AuthenticatedOrganizationsOrganizationIdRouteImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPartnersIndexRoute =
  AuthenticatedPartnersIndexRouteImport.update({
    id: '/partners/',
    path: '/partners/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPartnersPartnerIdRoute =
  AuthenticatedPartnersPartnerIdRouteImport.update({
    id: '/partners/$partnerId',
    path: '/partners/$partnerId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/calculators': typeof AuthenticatedCalculatorsRoute
  '/health': typeof AuthenticatedHealthRoute
  '/retention': typeof AuthenticatedRetentionRoute
  '/sensor-mappings': typeof AuthenticatedSensorMappingsRoute
  '/users': typeof AuthenticatedUsersRoute
  '/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdRoute
  '/partners/$partnerId': typeof AuthenticatedPartnersPartnerIdRoute
  '/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/partners/': typeof AuthenticatedPartnersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/calculators': typeof AuthenticatedCalculatorsRoute
  '/health': typeof AuthenticatedHealthRoute
  '/retention': typeof AuthenticatedRetentionRoute
  '/sensor-mappings': typeof AuthenticatedSensorMappingsRoute
  '/users': typeof AuthenticatedUsersRoute
  '/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdRoute
  '/partners/$partnerId': typeof AuthenticatedPartnersPartnerIdRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/partners': typeof AuthenticatedPartnersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/audit': typeof AuthenticatedAuditRoute
  '/_authenticated/calculators': typeof AuthenticatedCalculatorsRoute
  '/_authenticated/health': typeof AuthenticatedHealthRoute
  '/_authenticated/retention': typeof AuthenticatedRetentionRoute
  '/_authenticated/sensor-mappings': typeof AuthenticatedSensorMappingsRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/_authenticated/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdRoute
  '/_authenticated/partners/$partnerId': typeof AuthenticatedPartnersPartnerIdRoute
  '/_authenticated/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/_authenticated/partners/': typeof AuthenticatedPartnersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/calculators'
    | '/health'
    | '/retention'
    | '/sensor-mappings'
    | '/users'
    | '/organizations/$organizationId'
    | '/partners/$partnerId'
    | '/organizations/'
    | '/partners/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/calculators'
    | '/health'
    | '/retention'
    | '/sensor-mappings'
    | '/users'
    | '/organizations/$organizationId'
    | '/partners/$partnerId'
    | '/organizations'
    | '/partners'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/audit'
    | '/_authenticated/calculators'
    | '/_authenticated/health'
    | '/_authenticated/retention'
    | '/_authenticated/sensor-mappings'
    | '/_authenticated/users'
    | '/_authenticated/organizations/$organizationId'
    | '/_authenticated/partners/$partnerId'
    | '/_authenticated/organizations/'
    | '/_authenticated/partners/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/audit': {
      id: '/_authenticated/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthenticatedAuditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calculators': {
      id: '/_authenticated/calculators'
      path: '/calculators'
      fullPath: '/calculators'
      preLoaderRoute: typeof AuthenticatedCalculatorsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/health': {
      id: '/_authenticated/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof AuthenticatedHealthRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/retention': {
      id: '/_authenticated/retention'
      path: '/retention'
      fullPath: '/retention'
      preLoaderRoute: typeof AuthenticatedRetentionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sensor-mappings': {
      id: '/_authenticated/sensor-mappings'
      path: '/sensor-mappings'
      fullPath: '/sensor-mappings'
      preLoaderRoute: typeof AuthenticatedSensorMappingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations/': {
      id: '/_authenticated/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthenticatedOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations/$organizationId': {
      id: '/_authenticated/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/partners/': {
      id: '/_authenticated/partners/'
      path: '/partners'
      fullPath: '/partners/'
      preLoaderRoute: typeof AuthenticatedPartnersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/partners/$partnerId': {
      id: '/_authenticated/partners/$partnerId'
      path: '/partners/$partnerId'
      fullPath: '/partners/$partnerId'
      preLoaderRoute: typeof AuthenticatedPartnersPartnerIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAuditRoute: typeof AuthenticatedAuditRoute
  AuthenticatedCalculatorsRoute: typeof AuthenticatedCalculatorsRoute
  AuthenticatedHealthRoute: typeof AuthenticatedHealthRoute
  AuthenticatedRetentionRoute: typeof AuthenticatedRetentionRoute
  AuthenticatedSensorMappingsRoute: typeof AuthenticatedSensorMappingsRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedOrganizationsOrganizationIdRoute: typeof AuthenticatedOrganizationsOrganizationIdRoute
  AuthenticatedPartnersPartnerIdRoute: typeof AuthenticatedPartnersPartnerIdRoute
  AuthenticatedOrganizationsIndexRoute: typeof AuthenticatedOrganizationsIndexRoute
  AuthenticatedPartnersIndexRoute: typeof AuthenticatedPartnersIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAuditRoute: AuthenticatedAuditRoute,
  AuthenticatedCalculatorsRoute: AuthenticatedCalculatorsRoute,
  AuthenticatedHealthRoute: AuthenticatedHealthRoute,
  AuthenticatedRetentionRoute: AuthenticatedRetentionRoute,
  AuthenticatedSensorMappingsRoute: AuthenticatedSensorMappingsRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedOrganizationsOrganizationIdRoute:
    AuthenticatedOrganizationsOrganizationIdRoute,
  AuthenticatedPartnersPartnerIdRoute: AuthenticatedPartnersPartnerIdRoute,
  AuthenticatedOrganizationsIndexRoute: AuthenticatedOrganizationsIndexRoute,
  AuthenticatedPartnersIndexRoute: AuthenticatedPartnersIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
